export type TPortState = {
	searchedPorts: IPortSearchForm[] | [];
	isPortSearchBusy: boolean;
	selectedPortGeometry: IPortGeometry | null;
};

export interface IPortSearchForm {	
	name: string;
	country: string;
}

export interface IPortGeometryProperties {	
    portName: string;
	country: string;
}

export interface IPortGeometry {
	type: string;
	geometry: object;
	properties: IPortGeometryProperties;
}

// Slice name in the ...Slice.ts file
export const PORT = 'port';

export const portSagaActionTypes = {
	SEARCH_PORTS_REQUEST: `${PORT}/searchPortsRequest`,	
    GET_PORT_GEOMETRY_BY_NAME_AND_COUNTRY_REQUEST: `${PORT}/getPortGeometryByNameAndCountryRequest`,
	DISPLAY_OUTPUT_BY_PORT_GEOMETRY_REQUEST: `${PORT}/displayOutputByPortGeometryRequest`,
} as const;
